import { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './InstitutionTypeSelection.module.scss';
import RadioButton from '../../../components/RadioButton/RadioButton';

const InstitutionTypeSelection = ({ onSelectInstitutionType, onBack }) => {
  const [selectedType, setSelectedType] = useState('existing');

  const handleContinue = () => {
    if (selectedType) {
      onSelectInstitutionType(selectedType);
    }
  };

  return (
    <div className={styles.institutionTypeWrapper}>
      <div className={styles.container}>
        {/* Main Container */}
        <div className={styles.mainContainer}>
          <div className={styles.contentBox}>
            <h1 className={styles.title}>Institutional Users</h1>
            <p className={styles.description}>
              Select the 'Existing Institution' option and follow the steps if you are an existing
              Therapeutic Guidelines customer.
            </p>

            {/* Selection Options */}
            <div className={styles.optionsContainer}>
              {/* Existing Institution */}
              <div
                className={`${styles.optionButton} ${selectedType === 'existing' ? styles.selected : ''}`}
              >
                <RadioButton
                  checked={selectedType === 'existing'}
                  size="lg"
                  onChange={() => setSelectedType('existing')}
                  label="Existing Institution"
                  className={styles.radioOption}
                />
              </div>

              {/* New Institution */}
              <div
                className={`${styles.optionButton} ${selectedType === 'new' ? styles.selected : ''}`}
              >
                <RadioButton
                  checked={selectedType === 'new'}
                  size="lg"
                  onChange={() => setSelectedType('new')}
                  label="New Institution"
                  className={styles.radioOption}
                />
              </div>
            </div>

            {/* Continue Button */}
            <button type="button" onClick={handleContinue} className={styles.continueButton}>
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

InstitutionTypeSelection.propTypes = {
  onSelectInstitutionType: PropTypes.func.isRequired,
  onBack: PropTypes.func
};

export default InstitutionTypeSelection;
